import * as yup from 'yup';

export const demographicsFiltersValidationSchema = yup.object().shape({
  initialDemographicsDateFrom: yup.string(),
  initialDemographicsDateTo: yup.string(),
});
